import { axiosAjax } from './common'

export default {
  // get all project
  getProject (params) {
    return axiosAjax('/project', 'get', {params: params})
  },
  getResourceList (params) {
    return axiosAjax('/project_resource', 'get', {params: params})
  },
  createSqlApplication (params) {
    return axiosAjax('/sql_application_resource', 'post', {data: params})
  },
  getMySqlApplication (params) {
    return axiosAjax('/sql_application_resource', 'get', {params: params})
  },
  getApprovingApplication (params) {
    return axiosAjax('/sql_application/approving', 'get', {params: params})
  },
  getApprovedApplication (params) {
    return axiosAjax('/sql_application/approved', 'get', {params: params})
  },
  getSafeApplication (params) {
    return axiosAjax('/project/need_safe_mode', 'get', {params: params})
  },
  createSafeModeApply (params) {
    return axiosAjax('/safe_mode_application', 'post', {data: params})
  },
  getMySafeModeApply (params) {
    return axiosAjax('/safe_mode_application', 'get', {params: params})
  },
  getSafeApprovingApply (params) {
    return axiosAjax('/safe_mode_application/approving', 'get', {params: params})
  },
  getSafeApprovedApply (params) {
    return axiosAjax('/safe_mode_application/approved', 'get', {params: params})
  },
  getMyApplyDetail (params) {
    return axiosAjax('/sql_application/detail', 'get', {params: params})
  },
  deleteSqlDetail (applicationId) {
    return axiosAjax('/sql_application_resource/' + applicationId, 'delete')
  },
  excuteSqlApplication (params) {
    return axiosAjax('/passing/sql_application', 'get', {params: params})
  },
  rejectSqlApplication (params, id) {
    return axiosAjax('/sql_application_resource/' + id, 'patch', {data: params})
  },
  getSafeDetail (id) {
    return axiosAjax('/safe_mode_application/' + id, 'get', null, true)
  },
  deleteSafeApply (id) {
    return axiosAjax('/safe_mode_application/' + id, 'delete')
  },
  doSafeExcute (params, id) {
    return axiosAjax('/safe_mode_application/' + id, 'patch', {data: params})
  },
  doSafeReject (params, id) {
    return axiosAjax('/safe_mode_application/' + id, 'patch', {data: params})
  }

}



// WEBPACK FOOTER //
// ./src/api/review.js